export enum CatalogSortEventName {
  SortApplied = 'Sort Applied',
}

export type CatalogSortEventProperties = {
  sortBy: string;
  // The sort control now renders on more than one catalog surface, so the event has to say which
  // one it came from; without these a brand-page sort is indistinguishable from a category one.
  component: string;
  id_section: string;
};
